import { useQuery } from 'react-query';
import * as SettingApis from '../apis/setting';
import { AxiosError } from 'axios';

export type IStripeCard = SettingApis.FetchCardsResponse['cards'][0];

const getStripeCards = async (): Promise<{ cards: Array<IStripeCard> }> => {
  const {
    data: { cards },
  } = await SettingApis.fetchCards();
  return { cards };
};

const useQueryStripeCards = ({
  onError,
}: { onError?: (error: AxiosError) => void } = {}) => {
  const {
    data,
    isLoading: is_loading,
    isError: is_error,
    refetch,
  } = useQuery(['getStripeCards'], () => getStripeCards(), { onError });

  return {
    data,
    is_loading,
    is_error,
    refetch,
  };
};

export default useQueryStripeCards;
